import { HttpErrorResponse } from '@angular/common/http';
import {
	NotFoundExceptionModel,
	UnhandledExceptionModel,
	UnprocessableEntityExceptionModel,
	ValidationErrorModel,
} from '@woolworthsnz/trader-api';
import { UnauthorizedExceptionModel } from '../ui-models';

export function getFirstHttpErrorMessage(httpErrorResponse: HttpErrorResponse): any {
	if (!httpErrorResponse.error) {
		return undefined;
	}

	switch (httpErrorResponse.status) {
		case 400:
			const validationError: ValidationErrorModel = httpErrorResponse.error;
			return validationError.errors?.[0].message;
		case 401:
			const unauthorisedError: UnauthorizedExceptionModel = httpErrorResponse.error;
			return unauthorisedError.message;
		case 404:
			const notFoundError: NotFoundExceptionModel = httpErrorResponse.error;
			return notFoundError.message;
		case 422:
			const unprocessableError: UnprocessableEntityExceptionModel = httpErrorResponse.error;
			return unprocessableError?.messages?.[0] || (unprocessableError as any)?.Messages?.[0]; // backward compatibility
		case 500:
			const unhandledError: UnhandledExceptionModel = httpErrorResponse.error;
			return unhandledError?.message || (unhandledError as any)?.Message; // backward compatibility
		default:
			return undefined;
	}
}
